import { useContext } from 'react';
import { HSSApplicationContext, ApplicationStateContext } from '../providers/HSSInfrastructureProvider';

export const useApplicationState = (): HSSApplicationContext => useContext(ApplicationStateContext);
